import React from 'react'
import PropTypes from 'prop-types'

const Button = ({title, onClick, type = 'button', className = '', color = 'success'}) => (
  <button
    className={`custom-buttom ${color} ${className}`}
    onClick={onClick && onClick}
    type={type || 'button'}
  >
    <span className="text-button">
      {title || ''}
    </span>
  </button>
)

Button.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string
}

export default Button